<template>
  <div class="app-container">
    <div class="query">
      <el-form inline label-width="80px">
        <el-form-item label="设备名称" style="margin-top:15px;">
          <el-input v-model="DeviceName" placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="时间范围" style="margin-top:15px;">
          <el-select v-model="time" placeholder="请选择时间范围" @change="timeChange" style="width: 120px;">
            <el-option label="近一日" :value="0"></el-option>
            <el-option label="近七日" :value="1"></el-option>
            <el-option label="近一个月" :value="2"></el-option>
            <el-option label="近三个月" :value="3"></el-option>
            <el-option label="近半年" :value="4"></el-option>
            <el-option label="近一年" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-top:15px; width: 250px;">
          <el-date-picker style="vertical-align: -1px; width: 210px !important;" class="range-picker" v-model="dateRange" type="daterange"
            range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
            @change="onChange" clearable></el-date-picker>
        </el-form-item>
        <el-form-item style="margin-top:15px;">
          <el-button type="primary">搜索</el-button>
        </el-form-item>
        <el-form-item style="margin-left:20px;">
          <div class="c-lightgray">各种颜色代表的状态</div>
          <div class="status">
            <div class="item color0 sample">生产中</div>
            <div class="item color1 sample">待机中</div>
            <div class="item color2 sample">故障中</div>
            <div class="item color3 sample">关机中</div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="item_box">
      <div class="item" v-for="(item, index) in data" :key="index">
        <div class="tip">{{item.name}}</div>
        <div class="block" :class="item2.color" :style="'width: ' + item2.rate + '%;'"
          v-for="(item2, index2) in item.data2" :key="index2"></div>
        <div class="tip">利用率 <b>{{item.useRate}}%</b></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "analysis",
  data() {
    return {
      DeviceName: "",
      time: null,
      dateRange: [],
      data: [],
    }
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      let arr = [
        {
          name: "SBZS001", useRate: "70", vgroup: [
            { Status: 1, value: 100, },
            { Status: 0, value: 100, },
            { Status: 1, value: 200, },
            { Status: 2, value: 150, },
            { Status: 1, value: 80, },
            { Status: 3, value: 100, },
            { Status: 1, value: 60, },
          ]
        },
        {
          name: "SBZS002", useRate: "50", vgroup: [
            { Status: 3, value: 100, },
            { Status: 2, value: 50, },
            { Status: 0, value: 150, },
            { Status: 1, value: 120, },
            { Status: 0, value: 100, },
            { Status: 2, value: 80, },
            { Status: 3, value: 90, },
          ]
        },
      ];
      arr.forEach(e => {
        let obj = { total: 0, name: e.name, useRate: e.useRate, data2: [] };
        e.vgroup.forEach(n => {
          obj.total += n.value;
        })
        e.vgroup.forEach(n => {
          obj.data2.push({ color: "color" + n.Status, value: n.value, rate: (n.value / obj.total * 100).toFixed(1) })
        })
        this.data.push(obj);
      })
      console.log(this.data[0]);
    },
    timeChange(e) {
      let today = this.$commonJs.getToday();
      let now = (new Date(today)).getTime();
      let s = "";
      let result = "";
      switch (e) {
        case 0:
          s = new Date(now - 86400000);
          result = this.$commonJs.toDateString(s);
          break;
        case 1:
          s = new Date(now - 7 * 86400000);
          result = this.$commonJs.toDateString(s);
          break;
        case 2:
          s = new Date(now - 30 * 86400000);
          result = this.$commonJs.toDateString(s);
          break;
        case 3:
          s = new Date(now - 90 * 86400000);
          result = this.$commonJs.toDateString(s);
          break;
        case 4:
          s = new Date(now - 180 * 86400000);
          result = this.$commonJs.toDateString(s);
          break;
        case 5:
          s = new Date(now - 365 * 86400000);
          result = this.$commonJs.toDateString(s);
          break;
      }
      this.dateRange = [result, today];
    },
    onChange(e) {
      this.time = null;
    },
  }
};
</script>
<style scoped lang="scss">
.query {
  border-bottom: 2px solid #eee;
  padding-bottom: 0 !important;
  .status {
    display: flex;
    .item {
      color: #fff;
      text-align: center;
      padding: 0 12px;
    }
  }
}

.item_box {
  font-size: 0;
  width: 100%;
  padding: 0;
  .item {
    border-bottom: 1px solid #eee;
    padding: 20px 0;
    display: flex;
    .tip {
      text-align: center;
      line-height: 40px;
      display: inline-block;
      width: 150px;
      font-size: 18px;
      vertical-align: text-bottom;
    }
    .item2 {
      width: calc(100% - 300px);
      white-space: nowrap;
      height: 40px;
      .block {
        height: 100%;
        display: inline-block;
      }
    }
  }
}

.color0 {
  background-color: #33ceb9;
}

.color1 {
  background-color: #db7d4e;
}

.color2 {
  background-color: #e14141;
}

.color3 {
  background-color: #7b7b7b;
}

.sample{
  border-radius: 4px;
  margin: 2px;
}

</style>